import { morph } from '@theme/morph';
import { CartAddEvent } from '@theme/events';

document.addEventListener("DOMContentLoaded", function () {
  const starterPackManager = {
    totalQuantity: 0,
    productQuantities: {},
    addToCartBtn: document.getElementById("addToCartBtn"),
    requiredBagCount: 5,
    isSubscription: false,

    // Variant data read from hidden element rendered by Liquid
    variants: {
      onetime: { id: null, price: '', comparePrice: '' },
      subscription: { id: null, price: '', comparePrice: '', sellingPlanId: null }
    },

    init() {
      this.loadVariantData();
      this.bindEvents();
      this.initializeQuantitySelectors();
      this.updateSubscriptionVisualState(this.isSubscription);
      this.updatePriceDisplay();
      this.updateCartButton();
    },

    // ──────────────────────────────────────────
    // Variant data from Liquid
    // ──────────────────────────────────────────

    loadVariantData() {
      const el = document.getElementById('starterPackVariantData');
      if (!el) return;

      this.variants.onetime.id = el.dataset.onetimeId || null;
      this.variants.onetime.price = el.dataset.onetimePrice || '';
      this.variants.onetime.comparePrice = el.dataset.onetimeComparePrice || '';

      this.variants.subscription.id = el.dataset.subscriptionId || null;
      this.variants.subscription.price = el.dataset.subscriptionPrice || '';
      this.variants.subscription.comparePrice = el.dataset.subscriptionComparePrice || '';
      this.variants.subscription.sellingPlanId = el.dataset.sellingPlanId || null;
      this.variants.subscription.displayPrice = el.dataset.subscriptionDisplayPrice || this.variants.subscription.price;
    },

    getActiveVariant() {
      return this.isSubscription ? this.variants.subscription : this.variants.onetime;
    },

    // ──────────────────────────────────────────
    // Price display
    // ──────────────────────────────────────────

    updatePriceDisplay() {
      const variant = this.getActiveVariant();
      const cartPrice = document.getElementById('cartPrice');
      const cartComparePrice = document.getElementById('cartComparePrice');

      if (this.isSubscription && variant.displayPrice) {
        // Show discounted price + original as strikethrough
        if (cartPrice) cartPrice.textContent = variant.displayPrice;
        if (cartComparePrice) {
          cartComparePrice.textContent = this.variants.onetime.price;
          cartComparePrice.style.display = 'inline';
        }
      } else {
        if (cartPrice) cartPrice.textContent = variant.price;
        if (cartComparePrice) {
          if (variant.comparePrice) {
            cartComparePrice.textContent = variant.comparePrice;
            cartComparePrice.style.display = 'inline';
          } else {
            cartComparePrice.style.display = 'none';
          }
        }
      }
    },

    // ──────────────────────────────────────────
    // Subscription / One-time toggle
    // ──────────────────────────────────────────

    handleSubscriptionChange(e) {
      this.isSubscription = e.target.id === 'subscribe';
      this.updateSubscriptionVisualState(this.isSubscription);
      this.updatePriceDisplay();
      this.updateCartButton();

      // Update URL variant param
      const variant = this.getActiveVariant();
      if (variant.id) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      // Debug
      const debugType = document.getElementById('debugType');
      if (debugType) debugType.textContent = this.isSubscription ? 'subscription' : 'one-time';
      const debugVariant = document.getElementById('debugVariant');
      if (debugVariant) debugVariant.textContent = variant.id || 'none';
    },

    updateSubscriptionVisualState(isSubscription) {
      const leftSection = document.querySelector('.bkn-starter-pack-left-section');
      const rightSection = document.querySelector('.bkn-starter-pack-right-section');
      const subscribeBenefits = document.querySelector('.bkn-starter-pack-subscribe-benefits');
      const subscribeFooter = document.querySelector('.bkn-starter-pack-subscribe-footer');
      const onetimeBenefits = document.querySelector('.bkn-starter-pack-onetime-benefits');
      const onetimeFooter = document.querySelector('.bkn-starter-pack-onetime-footer');

      if (isSubscription) {
        if (leftSection) leftSection.classList.remove('bkn-starter-pack-not-selected');
        if (rightSection) rightSection.classList.add('bkn-starter-pack-not-selected');
        if (subscribeBenefits) subscribeBenefits.style.display = 'flex';
        if (subscribeFooter) subscribeFooter.style.display = 'block';
        if (onetimeBenefits) onetimeBenefits.style.display = 'none';
        if (onetimeFooter) onetimeFooter.style.display = 'none';
      } else {
        if (leftSection) leftSection.classList.add('bkn-starter-pack-not-selected');
        if (rightSection) rightSection.classList.remove('bkn-starter-pack-not-selected');
        if (subscribeBenefits) subscribeBenefits.style.display = 'none';
        if (subscribeFooter) subscribeFooter.style.display = 'none';
        if (onetimeBenefits) onetimeBenefits.style.display = 'flex';
        if (onetimeFooter) onetimeFooter.style.display = 'block';
      }
    },

    // ──────────────────────────────────────────
    // Quantity selectors
    // ──────────────────────────────────────────

    initializeQuantitySelectors() {
      document.querySelectorAll("[data-product]").forEach((element) => {
        if (element.classList.contains("bkn-starter-pack-quantity-selector")) {
          const productId = element.getAttribute("data-product");
          if (productId) {
            this.productQuantities[productId] = 0;
            this.updateQuantitySelector(productId);
          }
        }
      });
    },

    handleSelectClick(e) {
      const button = e.target;
      const productId = button.getAttribute("data-product");

      if (this.totalQuantity >= this.requiredBagCount) return;

      this.productQuantities[productId] = 1;
      this.updateQuantitySelector(productId);
      this.calculateTotalQuantity();
      this.updateCartButton();
    },

    updateQuantitySelector(productId) {
      const selector = document.querySelector(
        `[data-product="${productId}"].bkn-starter-pack-quantity-selector`
      );
      if (!selector) return;

      const qtyControls = selector.querySelector(".bkn-starter-pack-qty-controls");
      const selectBtn = selector.querySelector(".bkn-starter-pack-select-btn");
      const quantityDisplay = selector.querySelector(".bkn-starter-pack-quantity");

      const quantity = this.productQuantities[productId] || 0;
      const atMax = this.totalQuantity >= this.requiredBagCount;

      if (quantity === 0) {
        if (qtyControls) qtyControls.style.display = "none";
        if (selectBtn) {
          selectBtn.style.display = "flex";
          if ('disabled' in selectBtn) selectBtn.disabled = atMax;
          selectBtn.style.opacity = atMax ? "0.5" : "1";
        }
      } else {
        if (qtyControls) qtyControls.style.display = "flex";
        if (selectBtn) selectBtn.style.display = "none";
        if (quantityDisplay) quantityDisplay.textContent = quantity.toString();

        const plusBtn = selector.querySelector(".bkn-starter-pack-plus");
        if (plusBtn && 'disabled' in plusBtn) {
          plusBtn.disabled = atMax;
          plusBtn.style.opacity = atMax ? "0.3" : "1";
        }
      }
    },

    handleQuantityChange(e) {
      const button = e.target;
      const action = button.getAttribute("data-action");
      const productId = button.getAttribute("data-product");

      let currentQty = this.productQuantities[productId] || 0;

      if (action === "increase") {
        if (this.totalQuantity >= this.requiredBagCount) return;
        currentQty++;
      } else if (action === "decrease" && currentQty > 0) {
        currentQty--;
      }

      this.productQuantities[productId] = currentQty;
      this.updateQuantitySelector(productId);
      this.calculateTotalQuantity();
      this.updateCartButton();
    },

    calculateTotalQuantity() {
      this.totalQuantity = Object.values(this.productQuantities).reduce((sum, qty) => sum + qty, 0);

      Object.keys(this.productQuantities).forEach((productId) => {
        this.updateQuantitySelector(productId);
      });

      const debugTotal = document.getElementById("totalQuantity");
      if (debugTotal) debugTotal.textContent = this.totalQuantity;
    },

    // ──────────────────────────────────────────
    // Cart button
    // ──────────────────────────────────────────

    updateCartButton() {
      const cartButtonText = document.getElementById("cartButtonText");
      const variant = this.getActiveVariant();
      const price = (this.isSubscription && variant.displayPrice) ? variant.displayPrice : (variant.price || '$59.95');

      const shouldDisable = this.totalQuantity !== this.requiredBagCount;

      if (this.addToCartBtn && 'disabled' in this.addToCartBtn) {
        this.addToCartBtn.disabled = shouldDisable;
      }
      if (this.addToCartBtn) {
        this.addToCartBtn.style.opacity = shouldDisable ? "0.6" : "1";
      }
      if (cartButtonText) {
        if (this.totalQuantity < this.requiredBagCount) {
          const remaining = this.requiredBagCount - this.totalQuantity;
          cartButtonText.textContent = `Select ${remaining} more bag${remaining > 1 ? 's' : ''} • ${price}`;
        } else {
          cartButtonText.textContent = `Add to Cart • ${price}`;
        }
      }
    },

    // ──────────────────────────────────────────
    // Events
    // ──────────────────────────────────────────

    bindEvents() {
      document.addEventListener("click", (e) => {
        if (e.target.classList.contains("bkn-starter-pack-qty-btn")) {
          this.handleQuantityChange(e);
        }

        if (e.target.classList.contains("bkn-starter-pack-select-btn")) {
          this.handleSelectClick(e);
        }

        if (e.target.closest(".bkn-starter-pack-add-to-cart-btn")) {
          e.preventDefault();
          this.handleAddToCart(e);
        }
      });

      document.addEventListener("change", (e) => {
        if (e.target.name === "purchase-type") {
          this.handleSubscriptionChange(e);
        }
      });
    },

    // ──────────────────────────────────────────
    // Add to cart
    // ──────────────────────────────────────────

    handleAddToCart(e) {
      if (this.totalQuantity !== this.requiredBagCount) {
        console.warn(`Must select exactly ${this.requiredBagCount} bags`);
        return;
      }

      const variant = this.getActiveVariant();
      
      if (!variant.id) {
        console.error('No variant ID found');
        return;
      }

      const selectedFlavors = this.getSelectedFlavors();

      const item = {
        id: variant.id,
        quantity: 1,
        properties: {
          ...selectedFlavors.reduce((acc, flavor, index) => {
            acc[`flavor_${index + 1}`] = flavor;
            return acc;
          }, {}),
          '_total_items': this.totalQuantity,
          '_bag_type': '5 Bags',
          '_purchase_type': this.isSubscription ? 'subscription' : 'one-time'
        }
      };

      // Attach selling plan for subscription
      if (this.isSubscription && this.variants.subscription.sellingPlanId) {
        item.selling_plan = this.variants.subscription.sellingPlanId;
      }

      this.addToCart({ items: [item] });
    },

    getSelectedFlavors() {
      const flavorCounts = {};

      Object.keys(this.productQuantities).forEach(productId => {
        const quantity = this.productQuantities[productId];
        if (quantity > 0) {
          const productCard = document.querySelector(`[data-product="${productId}"]`);
          if (productCard) {
            const productNameElement = productCard.closest('.bkn-starter-pack-product-card')?.querySelector('.bkn-starter-pack-product-name');
            if (productNameElement) {
              const productName = productNameElement.textContent.trim();
              flavorCounts[productName] = quantity;
            }
          }
        }
      });

      return Object.entries(flavorCounts).map(([flavor, qty]) => `${qty}x ${flavor}`);
    },

    addToCart(cartData) {
      const addToCartBtn = document.getElementById("addToCartBtn");
      const cartButtonText = document.getElementById("cartButtonText");

      if (addToCartBtn && 'disabled' in addToCartBtn) addToCartBtn.disabled = true;
      if (cartButtonText) cartButtonText.textContent = "ADDING TO CART...";

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cartData)
      })
      .then(response => response.ok ? response.json() : Promise.reject(new Error(`HTTP error! status: ${response.status}`)))
      .then(data => {
        this.showAddToCartSuccess();
        this.handleAddToCartSuccess(data);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        this.showAddToCartError(error);
      })
      .finally(() => {
        if (addToCartBtn && 'disabled' in addToCartBtn) addToCartBtn.disabled = false;
        this.updateCartButton();
      });
    },

    showAddToCartSuccess() {
      const cartButtonText = document.getElementById("cartButtonText");
      if (cartButtonText) {
        cartButtonText.textContent = "ADDED TO CART!";
        setTimeout(() => {
          this.updateCartButton();
        }, 2000);
      }
    },

    handleAddToCartSuccess(cartResponse) {
      const variant = this.getActiveVariant();

      const cartAddEvent = new CartAddEvent({}, variant.id || 'starter-pack', {
        source: 'starter-pack',
        variantId: variant.id,
        itemCount: cartResponse.item_count || 1,
        productId: variant.id
      });
      document.dispatchEvent(cartAddEvent);

      const starterPackEvent = new CustomEvent('starter-pack:added-to-cart', {
        detail: {
          flavors: this.getSelectedFlavors(),
          totalQuantity: this.totalQuantity
        },
        bubbles: true
      });
      document.dispatchEvent(starterPackEvent);

      // Open cart drawer
      const cartDrawerComponent = document.querySelector('cart-drawer-component');
      if (cartDrawerComponent && typeof cartDrawerComponent.open === 'function') {
        cartDrawerComponent.open();
      } else {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          const cartIcon = document.querySelector('[aria-label*="cart"]') ||
                          document.querySelector('.cart-icon') ||
                          document.querySelector('[data-cart-icon]');
          if (cartIcon) cartIcon.click();
        }
      }
    },

    showAddToCartError(error) {
      const cartButtonText = document.getElementById("cartButtonText");
      if (cartButtonText) {
        cartButtonText.textContent = "ERROR - TRY AGAIN";
        setTimeout(() => {
          this.updateCartButton();
        }, 3000);
      }
      console.error('Add to cart failed:', error);
    }
  };

  starterPackManager.init();
});
